import { palette } from '@client/theme/colors';
import { theme } from '@client/theme/constants';
import type { ThemeOptions } from '@mui/material';

declare module '@mui/material/Slider' {
  interface SliderPropsColorOverrides {
    success: true;
    warning: true;
  }
}

const Slider: ThemeOptions['components'] = {
  MuiSlider: {
    defaultProps: {
      color: 'warning',
    },
    styleOverrides: {
      root: {
        height: 'auto',

        '&.Mui-disabled': {
          '& > .MuiSlider-thumb': {
            display: 'none',
          },

          '& > .MuiSlider-track': {
            backgroundColor: palette.warning.main,
          },
        },
      },
      track: {
        height: 3,
        borderRadius: 0,
        border: 'none',
      },
      rail: {
        height: 3,
        borderRadius: 0,
        backgroundColor: palette.grey[500],
      },
      thumb: {
        backgroundColor: palette.grey[50],
        borderWidth: 0,
        height: 18,
        width: 18,

        '&::before': {
          backgroundColor: theme.palette.grey[200],
          borderColor: theme.palette.grey[500],
          borderStyle: 'solid',
          borderWidth: 3,
          boxShadow: 'none',
          height: 18,
          width: 18,
        },
      },
    },
  },
};

export default Slider;
